module.exports = __webpack_public_path__ + "img/main.41c967e3.jpg";